const { connect } = require('react-redux');
const resultComponent = require('../component/resultComponent').default;
const { actions: { reboot } } = require('../../../../reducers').default;
const { modalType } = require('../../../../define/screenType').default;
// ======================

const mapStateToProps = (state) => {
    const { screenState, playerState, gameState, appState } = state;
    return {
        isModalOpen: screenState.modal === modalType.MODAL_RESULT,
        soundEnable: appState.soundEnable,
        playerState,
        gameState
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleTitleClick: () => {
            dispatch(reboot());
        }
    };
};

export const ResultContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(resultComponent);